import { SelectItem, createSelectItem } from 'vet-bones/utils/select';

export const stringToSelectItem = (item: string): SelectItem =>
  createSelectItem(item, item);
